<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="3">
        <wapi-panel :title="'Фильтр'">
          <template v-slot:content>
            <v-select
              v-model="selected"
              :items="users"
              item-text="name"
              item-value="id"
              label="Клиент"
              @input="onChangeUser"
              dense
              outlined
            ></v-select>
          </template>
        </wapi-panel>
      </v-col>
      <v-col cols="12" md="9">
        <wapi-panel :title="'Список договоров'">
          <template v-slot:content>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th># Id</th>
                    <th>Название</th>
                    <th>Статус</th>
                    <th>Дата создания</th>
                    <th>Дата завершения</th>
                    <th>Действие</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="contract in contracts" v-bind:key="contract.id">
                    <th>{{ contract.id }}</th>
                    <td>{{ contract.name }}</td>
                    <td>
                      <wapi-status v-model="contract.status" />
                    </td>
                    <td>{{ contract.create_date }}</td>
                    <td>{{ contract.expiration_date }}</td>
                    <td>
                      <v-row>
                        <v-btn
                          @click="openContract(contract)"
                          color="primary"
                          fab
                          x-small
                          elevation="0"
                        >
                          <v-icon>mdi-grease-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          @click="deleteAction(contract)"
                          color="error"
                          fab
                          x-small
                          elevation="0"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
    <wapi-delete-dialog v-model="deleteDialog" @delete="deleteContract" :text="deleteDialogText" />
  </v-container>
</template>

<script>
import WapiPanel from "../../components/WapiPanel";
import WapiStatus from "../../components/WapiStatus";
import WapiDeleteDialog from "../../components/WapiDeleteDialog";

export default {
  name: "GeoMapContractsView",
  title: "Договоры для карт",
  components: {
    WapiPanel,
    WapiStatus,
    WapiDeleteDialog
  },
  props: {
    userId: String
  },
  data: function() {
    return {
      users: [],
      selected: "",
      deleteDialogText: "",
      contract: null,
      deleteDialog: false
    };
  },
  watch: {
    async userId(val) {
      if (val) {
        this.selected = val;
        await this.load(val);
      }
    }
  },
  async mounted() {
    await this.$store.dispatch("FETCH_USERS");
    this.users = this.$store.getters.USERS;

    this.selected = this.users[0].id;
    const userId = this.selected;

    await this.onChangeUser(userId);
  },
  computed: {
    contracts() {
      return this.$store.getters.GEOMAP_CONTRACTS;
    }
  },
  methods: {
    async onChangeUser(userId) {
      await this.$store.dispatch("SET_LOADING", true);

      await this.load(userId);

      await this.$store.dispatch("SET_LOADING", false);
    },
    async load(userId) {
      try {
        await this.$store.dispatch("FETCH_GEOMAP_USER_CONTRACTS", {
          userId: userId,
          take: 1000,
          skip: 0
        });
      } catch (err) {
        this.$store.dispatch("PUSH_ERROR", err);
      }
    },
    async openContract(contract) {
      this.$router.push({
        name: "GEOMAP_CONTRACT",
        params: { userId: contract.user_id, contractId: contract.id }
      });
    },
    async deleteAction(contract) {
      this.contract = contract;
      this.deleteDialogText = `Вы действительно хотите удалить договор [${contract.id}]?`;
      this.deleteDialog = true;
    },
    async deleteContract() {
      await this.$store.dispatch("SET_LOADING", true);
      await this.$store.dispatch("DELETE_GEOMAP_CONTRACT", {
        contractId: this.contract.id,
        userId: this.contract.user_id
      });
      await this.load(this.contract.user_id);
      await this.$store.dispatch("SET_LOADING", false);
      this.deleteDialog = false;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async () => {});
  }
};
</script>